import React from 'react'
import { Button } from 'react-bootstrap'

const CourseDetailsButton = ({
    children,
    onClick = () => {},
    disabled,
    variant
}) => {
    return (
        <div style={{ paddingBottom: '10px'}}>
            <Button
                block
                size='lg'
                onClick={() => onClick()}
                disabled={disabled}
                variant={variant}
            >
                {children}
            </Button>
        </div>
    )
}

export default CourseDetailsButton